import { CandidateConferencePageComponent } from "./candidate-conference-page.component";
import { CandidateConferenceModule } from "./candidateConference/candidate-conference.module";
export const CandidateConferencePageModule = angular
    .module('candidateConferencePage', [CandidateConferenceModule])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('candidateConference', {
            url: '/candidateConference?c&j&jm&t&mode&sh&ws&m',
            component: CandidateConferencePageComponent.selector,
            data: {
                requireLogin: false
            }
        });
    }
])
    .component(CandidateConferencePageComponent.selector, CandidateConferencePageComponent.component)
    .name;
//# sourceMappingURL=candidate-conference-page.module.js.map